<template>
    <div class="wrap">
        <div class="wrap_inner">
            <div class="wrap_main">
				<div class='mainlist' :style="{position:(disShow11==1||disShow12==1||disShow13==1)?'absolute':'',top:0,bottom:0,overflow:(disShow11==1||disShow12==1||disShow13==1)?'hidden':'auto'}">
				<div class="blkm">
				   <img src="./image/plan.png" style="width: 100%;height: 100%"></img>
				   <div class="blkps">
					   <div class="egtxt" @click="getRule">积分</div>
					   <div class="egtv">16992</div>
					   <div class="egmy">我的积分</div>
				   </div>
				</div>
				<div>
				    <van-tabs v-model="active2" color="#0080ff">
				      <van-tab title="积分兑换">
				        <div>
				            <div v-if="datas1.length>0">
				            	<div class="chSty">
									<EXCHANGE @exchange="exchange" :item="datas1"></EXCHANGE>
								</div>
				            </div>
				            <div v-else class="nData">暂无数据</div>
				        </div>
				      </van-tab>
				      <van-tab title="我的兑换">
				        <div class="mtop">
				            <div v-if="dataList.length>0">
				            	<div class="pannels">
				            		<div class="innerCell" @click="toDetail(item)" v-for="(item,index) in dataList" :key="index">
				            			<div class="syCell">
				            				<div class="cellsy">
				            					<div class="innerTitle">{{item.tit}}</div>
												<div class="stime" style="flex:2">{{item.time}}</div>
				            				</div>
											<div class="txtSty">
												{{item.value}}
											</div>
				            			</div>
				            		</div>
				            	</div>
				            </div>
				            <div v-else class="nData">暂无数据</div>
				        </div>
				      </van-tab>
				    </van-tabs>
				</div>
            </div>
			<div v-if="disShow11==1" style="width:100%;height:100%">
				<div ref="dig" class="mtblk" style="position:absolute;top:0;left:0;width:100%;height:100%;z-index:1000;opacity: 0.95;background: #333333;">
					<div class="dialogs">
						<div class="digtxt digtxt3">确认兑换吗？</div>
						<div class="txtx" @click="reback"><img src="./image/x@2x.png" style="position:absolute;top:0;right:0;width:100%;height:100%"></img></div>
						<div class="uBtn" style="display:flex;align-items:center;justify-content:center">
							<div class="reback" @click="reback">返回</div>
							<div class="submit" @click="submit2">确定</div>
						</div>
					</div>
				</div>
			</div>
			<div v-if="disShow13==1" style="width:100%;height:100%">
				<div ref="dig" class="mtblk" style="position:absolute;top:0;left:0;width:100%;height:100%;z-index:1000;opacity: 0.95;background: #333333;">
					<div class="dialogs2">
						<div class="digtxt">积分规则</div>
						<div class="txtx" @click="reback"><img src="./image/x@2x.png" style="position:absolute;top:0;right:0;width:100%;height:100%"></img></div>
						<div class="pSty">扫描需要应急响应的设备的二维码。扫描需要应急响应的设备的二维码。扫描需要应急响应的设备的二维码。扫描需要应急响应的设备的二维码。扫描需要应急响应的设备的二维码。扫描需要应急响应的设备的二维码。扫描需要应急响应的设备的二维码。扫描需要应急响应的设备的二维码。扫描需要应急响应的设备的二维码。</div>
						<div style="position:absolute;bottom:20px;left:0;width:100%;display:flex;align-items:center;justify-content:center">
							<div class="submit submit1" @click="reback">确定</div>
						</div>
					</div>
				</div>
			</div>
			<div v-if="disShow12==1" style="width:100%;height:100%">
				<div ref="dig" class="mtblk" style="position:absolute;top:0;left:0;width:100%;height:100%;z-index:1000;opacity: 0.95;background: #333333;">
					<div class="dialogs1">
						<img src="./image/exchange.png" class="eimg"></img>
						<div class="txtx" style='z-index:3000' @click="reback"><img src="./image/x@2x.png" style="position:absolute;top:0;right:0;width:100%;height:100%;"></img></div>
						<div class="titStys">
							<div class="digtkt">兑换成功</div>
							<div class="dhSty">
								<div class="digtmt">兑换成功赶紧查看~</div>
								<div class="digtut" @click='selectEg'>查看兑换</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div v-if="true" style="width:100%;height:100%">
				<div ref="dig" class="mtblk" style="position:absolute;top:0;left:0;width:100%;height:100%;z-index:1000;opacity: 0.95;background: #333333;">
					<div class="introSty">待上线，尽请期待。。。</div>
				</div>
			</div>
			</div>
			</div>
        </div>
    </div>
</template>
<script>
    import EXCHANGE from '@/components/exchange.vue'
    export default {
        name:'pjxq',
        components:{
            EXCHANGE,
        },
        data(){
            return {
				active2:0,
				dataList:[
					{
						id:'1',
						tit:'小米巨能写中性笔10支装 黑色 0.5mm',
						value:'-500',
						time:'2021/3/12'
					},
					{
						id:'1',
						tit:'小米巨能写中性笔10支装 黑色 0.5mm',
						value:'-500',
						time:'2021/3/12'
					},
					{
						id:'1',
						tit:'小米巨能写中性笔10支装 黑色 0.5mm',
						value:'-500',
						time:'2021/3/12'
					},
					{
						id:'1',
						tit:'小米巨能写中性笔10支装 黑色 0.5mm',
						value:'-500',
						time:'2021/3/12'
					},
					{
						id:'1',
						tit:'小米巨能写中性笔10支装 黑色 0.5mm',
						value:'-500',
						time:'2021/3/12'
					},
					{
						id:'1',
						tit:'小米巨能写中性笔10支装 黑色 0.5mm',
						value:'-500',
						time:'2021/3/12'
					},
				],
                datas1:[
					{
						img:require('./image/plan.png'),
						tit:'小米巨能写中性笔10支 装 黑色 0.5mm',
						value:'500',
						
					},
					{
						img:require('./image/plan.png'),
						tit:'小米巨能写中性笔10支 装 黑色 0.5mm',
						value:'500',
						
					},					{
						img:require('./image/plan.png'),
						tit:'小米巨能写中性笔10支 装 黑色 0.5mm',
						value:'500',
						
					},					{
						img:require('./image/plan.png'),
						tit:'小米巨能写中性笔10支 装 黑色 0.5mm',
						value:'500',
						
					},					{
						img:require('./image/plan.png'),
						tit:'小米巨能写中性笔10支 装 黑色 0.5mm',
						value:'500',
						
					},					{
						img:require('./image/plan.png'),
						tit:'小米巨能写中性笔10支 装 黑色 0.5mm',
						value:'500',
						
					},					{
						img:require('./image/plan.png'),
						tit:'小米巨能写中性笔10支 装 黑色 0.5mm',
						value:'500',
						
					},					{
						img:require('./image/plan.png'),
						tit:'小米巨能写中性笔10支 装 黑色 0.5mm',
						value:'500',
						
					},
				],
				disShow11:0,
				disShow12:0,
				disShow13:0
            }
        },
        methods:{
			exchange(data){
				if(data){
					this.disShow11=1
				}
			},
			reback(){
				this.disShow11=0
				this.disShow12=0
				this.disShow13=0
			},
			submit2(){
				this.disShow11=0
				this.disShow12=1
			},
			selectEg(){
				this.disShow12=0
				this.active2=1
			},
			getRule(){
				this.disShow13=1
			}
		},
        created(){
        }
    }
</script>
<style scoped>
	.nData{
	    width:100%;
	    height:60px;
	    display:flex;
	    justify-content:center;
	    align-items:center;
	    font-size:14px;
	}
    .wrap{
		position: absolute;
		top: 0;
		left:0;
		z-index:3000;
		width:100%;
		height:100%;
		overflow: auto;
		overflow-x:hidden;
		background:#e9eef2;
	}
	.wrap_inner{
		 min-height: 100%;
		 width:100%;
	}
	.wrap_main{
		position:absolute;
		width:100%;
		height:100%;
		box-sizing:border-box;
	    padding-bottom: 5px;
	}
	.introSty{
		position:absolute;
		width:100%;
		height:100%;
		line-height:667px;
		color:#fff;
		font-size:20px;
		text-align:center;
	}
    .mainlist{
        width:100%;
        height:100%;
    }
	.titStys{
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
	}
	.egInfo{
		width:335px;
		height:100%;
		margin:0 auto;
	}
	.dhSty{
		position:absolute;
		left:0;
		bottom:0;
		width:100%;
		height:110px;
	}
	.digtkt{
		width:100%;
		height:50px;
		line-height:50px;
		color:#fff;
		font-size: 24px;
		font-weight: 400;
		text-align: center;
	}
	.digtut{
		margin:10px auto;
		width: 211px;
		height: 45px;
		background: linear-gradient(140deg,#36b3fe 4%, #0080ff 96%);
		border-radius: 23px;
		font-size: 18px;
		font-weight: 400;
		color: #ffffff;
		line-height: 45px;
		text-align:center;
		
	}
	.digtmt{
		height: 32px;
		font-size: 16px;
		font-weight: 400;
		text-align: center;
		color: #333333;
		line-height: 32px;
	}
    .sImg{
        width: 100%;
        height: 91px;
    }
    .i_title{
        font-size: 12px;
        font-weight: 400;
        text-align: left;
        color: #333333;
        margin-left:18px;
    }
	.txtSty{
		flex:1;
		text-align:right!important;
		font-size: 24px;
		font-weight: 400;
		text-align: left;
		color: #000000;
		line-height: 30px;
	}
	.blkm{
		position:relative;width: 100%;height: 148px;
	}
	.egtxt{
		width: 100%;
		height: 28px;
		opacity: 1;
		font-size: 20px;
		font-weight: 400;
		text-align: center;
		color: #ffffff;
	}
	.egtv{
		margin-top:15px;
		width: 100%;
		height: 56px;
		opacity: 1;
		font-size: 40px;
		font-weight: 800;
		text-align:center;
		color: #ffffff;
	}
	
	
		.mtblk{
			width:100%;
			height:667px;
		}
		.dialogs{
			position:absolute;
			top:50%;
			left:50%;
			transform:translate(-50%,-50%);
			width: 285px;
			height: 179px;
			background: #fff;
			border-radius: 8px;
			z-index:1000
		}
		.dialogs1{
			position:absolute;
			top:50%;
			left:50%;
			transform:translate(-50%,-50%);
			width: 285px;
			height: 280px;
			background: #fff;
			border-radius: 8px;
			z-index:1000
		}
		.dialogs2{
			position:absolute;
			top:50%;
			left:50%;
			transform:translate(-50%,-50%);
			width: 285px;
			height: 384px;
			background: #fff;
			border-radius: 8px;
			z-index:1000
		}
		.eimg{
			width:100%;
			height:100%;
		}
		.digtxt{
			width: 200px;
			height: 28px;
			margin:0px auto;
			font-size: 20px;
			font-weight: 400;
			text-align: center;
			color: #003cff;
			line-height: 28px;
		}
		.txtx{
			position:absolute;
			top:12px;
			right:12px;
			width:12px;
			height:12px;
			flex:1;
		}
		.reback{
		    flex:0 0 100px;
		    height: 45px;
		    line-height:45px;
		    text-align:center;
		    background: #ffffff;
		    border: 2px solid #0080ff;
		    border-radius: 23px;
		    color:#0080ff;
		    font-size:18px;
		}
	.egmy{
		width: 100%;
		height: 22px;
		opacity: 0.7;
		font-size: 16px;
		font-weight: 400;
		text-align:center;
		color: #ffffff;
	}
	.chSty{
		display:flex;
		width:100%;
		height:100%;
		padding:13px 20px;
		box-sizing:border-box;
	}
    .engSty{
        display:flex;
        align-items:center;
        padding:9px 12px;
        height:62px;
        width: 309px;
        margin:20px auto;
        background: #ffffff;
        border-radius: 4px;
        box-shadow: 0px 3px 6px 0px rgba(16,82,139,0.16);
        font-size:12px;
    }
    .engSty>div{
        flex:1;
    }
    .engSty>div:nth-child(1){
        flex:0 0 44px;
    }
    .engSty>div:nth-child(3){
        flex:0 0 10px;
    }
    .tBut{
		position:relative;
        display:flex;
		flex-direction:column;
        width: 309px;
        height: 129px;
        margin:-30px auto;
		z-index:1000;
        background: #ffffff;
        border-radius: 8px;
        box-shadow: 0px 3px 6px 0px rgba(16,82,139,0.16);
        font-size:12px;
    }
	.tnCell{
		width:100%;
		height:80px;
		padding:0 20px;
		box-sizing:border-box;
		display:flex;
	}
	.mainlist{
	    width:100%;
	    height:100%;
	}
    .tnCell>div{
       flex:1;
    }
    .tCell{
        display:flex;
        flex-direction:column;
        justify-content:center;
        align-items:center;
    }
    .notice{
        display:flex;
        width: 90%px;
        height: 35px;
        padding:0 5%;
        margin:0px auto;
        background: #ffffff;
        border-radius: 4px;
        box-shadow: 0px 3px 6px 0px rgba(16,82,139,0.16);
        font-size:12px;
        align-items:center;
        justify-content:center;
    }
    .notice>div{
        flex:1;
    }
    .notice>div:nth-child(1){
        flex:0 0 19px;
    }
    .notice>div:nth-child(3){
        flex:0 0 22px;
    }
    .img1{
        width:25px;
        height:25px;
    }
	.mtop{
		margin-top:20px;
	}
	.uBtn{
		margin-top:50px;
	}
    .txt1{
        font-size:16px;
        margin-left:16px;
        color:#333;
    }
    .img2{
        width:22px;
        height:22px;
    }
    .img3{
        width:44spx;
        height:44px;
        margin-bottom:10px;
    }
    .img4{
        width:44spx;
        height:44px;
        margin-bottom:10px;
        margin-top:10px;
    }
    .blk1{
       display:flex;
       flex-direction:column;
       margin-left:20px;
    }
    .txtn{
        font-size:16px;
        font-weight:400;color:#333;
        margin-bottom:4px;
    }
	.txta1{
	   font-size:38px;font-weight:800
	}
	.txta2{
	   font-size:14px;font-weight:400
	}
	.txta3{
	  font-size:14px;font-weight:400
	}
	.tblk{
		position:absolute;
		top:0;
		left:0;
		width:100%;
		height:70px;
		padding:0px 22px;
		box-sizing:border-box;
		display:flex;
		align-items:center;
		justify-content:center;

	}
	.tblk1{
		display:flex;
		flex:0 0 44px;
	}
	.timg1{
		width:44px;
		height:44px;
	}
	.tblk2{
		flex:1;
		margin-left:15px;
	}
	.txtlk{
		display:flex;
		align-items:center;
	}
	.txtlk1{
		font-size: 14px;
		font-weight: 400;
		text-align: left;
		color: #ffffff;
		margin-bottom:5px;

	}
	.txtlk2{
		display:flex;
		flex:0 0 12px;
		flex-direction:column;
		width:12px;
		height:12px;
		border-radius:12px;
		background:#09F175;
		margin-right:5px;
		margin-top:2px;
	}
	.txtlk3{
		flex:0 0 1;
		font-size: 12px;
		font-weight: 400;
		text-align: left;
		color: #ffffff;
	}
	.tblk3{
		display:flex;
		flex:0 0 24px;
	}
	.timg3{
		font-size:30px;
		color:#fff;
		font-weight:bold;
	}
	.allTxt{
		margin:9px 0 9px 14px;
	}
	.mtblk{
		width:100%;
		height:667px;
	}
	.dialogs{
		position:absolute;
		top:50%;
		left:50%;
		transform:translate(-50%,-50%);
		width: 285px;
		height: 179px;
		background: #fff;
		border-radius: 8px;
		z-index:1000
	}
	.digtxt{
		width: 200px;
		height: 28px;
		margin:10px auto;
		font-size: 20px;
		font-weight: 400;
		text-align: center;
		color: #003cff;
		line-height: 33px;
	}
	.digtxt3{
		margin:20px auto;
	}
	.txtx{
		position:absolute;
		top:12px;
		right:12px;
		width:12px;
		height:12px;
		flex:1;
	}
	.reback{
	    flex:0 0 100px;
	    height: 45px;
	    line-height:45px;
	    text-align:center;
	    background: #ffffff;
	    border: 2px solid #0080ff;
	    border-radius: 23px;
	    color:#0080ff;
	    font-size:18px;
	}
	.submit{
	    flex:0 0 100px;
	    height: 45px;
	    line-height:45px;
	    text-align:center;
	    background: linear-gradient(140deg,#36b3fe 4%, #0080ff 96%);
	    border-radius: 23px;
	    color:#fff;
	    font-size:18px;
	}
	.submit1{
		flex:0 0 211px;
	}
	.blkps{
	    position:absolute;
		top:15px;
		left:0;
	    width:100%;
	    height:118px;
		text-align:center;
	}
	.blkrect{
	    width: 20px;
	    height: 2px;
	    background: #ffffff;
	}
	.txtku1{
	    margin:4px 0 10px 0;
	    font-size: 20px;
	    font-weight: 800;
	    text-align: left;
	    color: #ffffff;
	}
	.txtku2{
	    font-size: 16px;
	    font-weight: 400;
	    color: rgba(255,255,255,0.80);
	}
	.pannels{
	   margin-top:20px;
	   width: 335px;
	   height: 100%;
	   margin:0 auto;
	   opacity: 1;
	   border-radius: 4px;
   }
   .innerCell{
	   width:335px;
	   height:87px;
	   background:#fff;
	   padding:15px 16px;
	   box-sizing:border-box;
   }
   .syCell{
	   display:flex;
	   width:100%;
	   height:100%;
	   padding-bottom:10px;
	   border-bottom: 1px solid #bfbfbf;
   }
   .cellsy{
	   flex:0 0 179px;
   	   height:100%;
   }
   .innerSub{
	   margin-top:6px;
   }
   .innerTitle{
	   font-size: 16px;
	   color:#333333;
   }
   .sName{
	   font-size:12px;
	   color: #666666;
   }
   .stime{
	   font-size:12px;
	   color: #666666;
   }
   .pSty{
	   width: 100%;
	   height: 230px;
	   padding:5px 14px 20px 23px;
	   box-sizing: border-box;
	   margin:0 auto;
	   opacity: 1;
	   font-size: 14px;
	   font-weight: 400;
	   text-align: left;
	   color: #333333;
	   line-height: 28px;
	   text-indent:32px;
	   overflow-y:auto;
	   background-color: #fff;
   }
</style>
